import React, { useState} from 'react';
import { withRouter } from "react-router-dom";
import routes from '../Routes'
function Footer(props) {
    const [open,setopen]=useState("")
const footer_collink=(event)=>{
    console.log(event.target.getAttribute('value'))
    setopen(event.target.getAttribute('value'))
}
    return(
        <footer className="w-left">
        <div className="footer_content">
            <div className="container">
                <div className="row">
                	<div className="footer_col about_us">
                        <h3>STAY TUNED WITH US</h3>
                        <a >© 2020 softpulseinfotech.com</a>
						<ul className="ft-social">
							<li>
								<a href="https://twitter.com" target="_blank">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
										<path d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016
										c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992
										c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056
										c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152
										c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792
										c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44
										C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568
										C480.224,136.96,497.728,118.496,512,97.248z"></path>
									</svg>
								</a>
							</li>
							<li>
								<a href="https://www.facebook.com" target="_blank">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 155.139 155.139">
										<path id="f_1_" d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184
										c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452
										v20.341H37.29v27.585h23.814v70.761H89.584z"></path>
									</svg>
								</a>
							</li>
							<li>
								<a href="https://www.linkedin.com/company" target="_blank">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z"></path><path d="m.396 7.977h4.976v16.023h-4.976z"></path>
										<path d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z"></path>
									</svg>
								</a>
							</li>
						</ul>
                    </div>
                    <div className="footer_col" >
                        <h3>Jobs</h3>
                    
                        <ul className="fcol_1 footer_cont" style={{"display":"block"}}>
                           
                        <li onClick={()=>{props.history.push(routes.job);}}><a >Find Jobs</a></li>
                        <li onClick={()=>{props.history.push(routes.profile);}}><a >Profile</a></li>
                        </ul>
                    </div>
                    <div className="footer_col" >
                        <h3>Quick links</h3>
                        
                        <ul className="fcol_2 footer_cont" style={{"display":"block"}}>
                           
                            <li  onClick={()=>{props.history.push(routes.about);}}><a >About</a></li>
                         <li  onClick={()=>{props.history.push(routes.contact);}}><a>Contact Us</a></li>
                         <li  onClick={()=>{props.history.push(routes.home);}}><a >Home</a></li>
                        </ul>
                    </div>
                    <div className="footer_col contact_col" >
                        <h3>contact us</h3>
                      
                        <ul className="fcol_3 footer_cont" style={{"display":"block"}}>
                            <li><a><span><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/></svg>
                            </span>alexbll1988@gmail.com</a></li>
                            <li><a ><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg></span><span>DGW Apartment 1cx 999 Derrick Street Boston, MA 02130 USA.</span></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    )
// {  return (
//     <footer>
//     <div className="footer_content">
//         <div className="container">
//             <div className="row">
//                 <div className="footer_col col-12 col-lg-3">
//                     <h3>Jobs</h3>
//                     <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target=".fcol_1">
//                     Jobs<div className="colla_ico"></div>
//                     </button>
//                     <ul className="fcol_1 collapse">
//                         <li onClick={()=>{props.history.push(routes.job);}}><a >Find Jobs</a></li>
//                         <li onClick={()=>{props.history.push(routes.profile);}}><a >Profile</a></li>
//                     </ul>
//                 </div>
//                 <div className="footer_col col-12 col-lg-3">
//                     <h3>Quick links</h3>
//                     <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target=".fcol_2">
//                     Quick links<div className="colla_ico"></div>
//                     </button>
//                     <ul className="fcol_2 collapse">
//                         <li  onClick={()=>{props.history.push(routes.about);}}><a >About</a></li>
//                         <li  onClick={()=>{props.history.push(routes.contact);}}><a>Contact Us</a></li>
//                         <li  onClick={()=>{props.history.push(routes.home);}}><a >Home</a></li>
//                     </ul>
//                 </div>
//                 <div className="footer_col contact_col col-12 col-lg-3">
//                     <h3>contact us</h3>
//                     <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target=".fcol_3">
//                     Contact us<div className="colla_ico"></div>
//                     </button>
//                     <ul className="fcol_3 collapse">
//                         <li><a ><span className={"infosvg"} ><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/></svg>
//                         </span><span className="info">alexbll1988@gmail.com</span></a></li>
                       
//                         <li><a ><span className={"infosvg"}><svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg></span>
//                         <span className="info">DGW Apartment 1cx 999 Derrick Street Boston, MA 02130 USA</span>
//                         </a></li>
//                     </ul>
//                 </div>
//                 <div className="footer_col col-12 col-lg-3">
//                    {/* { <h3>Stay Tuned with us</h3>
//                     <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target=".fcol_4">
//                     Stay Tuned with us<div className="colla_ico"></div>
//                     </button>
//                     <div className="fcol_4 collapse">
//                         <form action="" method="">
//                             <input type="email" name="email" placeholder="Email"/>
//                             <input type="button" value="Send"/>
//                         </form>
//                     </div>} */}
//                     <h3>Stay Tuned with us</h3>
//                     {/* {<img src={require('../../images/demo_icon.png')}/>} */}
//                     <p>Loreum ipsum Loreum ipsum Loreum ipsum Loreum ipsum Loreum ipsumv vvLoreum ipsumLoreum ipsumLoreum ipsumLoreum ipsum</p>
//                     <ul class="ft-social">
                  
//                         <li><a href="https://twitter.com" target="_blank">
            
//                             <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  height="20px" width="20px"
//                                 viewBox="0 0 512 512"  >
//                                 <g>
//                                     <g>
//                                         <path d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016
//                                             c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992
//                                             c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056
//                                             c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152
//                                             c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792
//                                             c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44
//                                             C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568
//                                             C480.224,136.96,497.728,118.496,512,97.248z"/>
//                                     </g></g>
//                                 <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
//                             </svg>
//                         </a></li>
//                         <li><a href="https://www.facebook.com" target="_blank">

//                         <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  height="20px" width="20px"
//                             viewBox="0 0 155.139 155.139"  >
//                         <g>
//                             <path id="f_1_"  d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184
//                                 c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452
//                                 v20.341H37.29v27.585h23.814v70.761H89.584z"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g><g><g></g><g></g></g></g>
//                         </svg>

//                         </a></li>
                     
//                         <li><a href="https://www.linkedin.com/company" target="_blank">
//                         <svg id="Bold"  height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z"/><path d="m.396 7.977h4.976v16.023h-4.976z"/><path d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z"/></svg>
//                         </a></li>
//                     </ul>
//                 </div>
//             </div>
//         </div>
//     </div>
//     <div className="footer_bottom">
//         <p>powered by Softpulseinfotech.com @ 2020</p>
//     </div>
// </footer>
//   )}
}

//export default Home;
export default withRouter(Footer);